import { render, staticRenderFns } from "./Discovertv.vue?vue&type=template&id=69d5f8ac&scoped=true&"
import script from "./Discovertv.vue?vue&type=script&lang=js&"
export * from "./Discovertv.vue?vue&type=script&lang=js&"
import style0 from "./Discovertv.vue?vue&type=style&index=0&id=69d5f8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d5f8ac",
  null
  
)

export default component.exports